export default {
  status: '',
  token: '',
  userInfo: {},
  loading: false
}
